export default __webpack_public_path__ + "static/media/Hotwire.323200c4.svg";